import { useMemo } from 'react';
import { useTranslation } from '@aimsos/i18n';

import {
  addGroupMembers,
  createGroup,
  deleteGroup,
  updateGroup,
  validateApiResponse,
} from '../../../services';
import { mapApiGroupToUi } from '../utils/groupMappers';

/**
 * Group writes. Each handler resolves the UI result and REJECTS with the API message on a
 * non-2xx envelope, so the caller keeps its form open and raises the error toast.
 */
export const useGroupMutations = () => {
  const { t } = useTranslation('people-access');

  return useMemo(() => {
    const unwrap = async (request) =>
      validateApiResponse(await request, t('groups.errors.generic')).body;

    return {
      /** @param {{ name: string, description?: string }} payload */
      createGroup: async (payload) =>
        mapApiGroupToUi(
          await unwrap(
            createGroup({ name: payload.name, description: payload.description?.trim() ?? '' }),
          ),
        ),
      /** @param {{ name?: string, description?: string }} patch */
      updateGroup: async (groupId, patch) =>
        mapApiGroupToUi(await unwrap(updateGroup(groupId, patch))),
      addMembers: (groupId, memberIds) => unwrap(addGroupMembers(groupId, memberIds)),
      deleteGroup: (groupId) => unwrap(deleteGroup(groupId)),
    };
  }, [t]);
};
